import { SIGNUP_ERROR } from "src/domains/shared/constants/constants";

/**
 * 가입 거절의 `code`(IdP 예외 이름) → 기존 문구(`SIGNUP_ERROR`). 아는 코드가 없으면 `undefined` 다 — 호출부가 일반 실패 문구를
 * 쓴다. 백엔드 가입 API 가 Amplify 가 던지던 예외 이름을 `code` 로 그대로 싣기 때문에 문구 매핑이 바뀌지 않는다.
 */
export function signupErrorMessage(code: string | null, language: "ko" | "en"): string | undefined {
  const known = Object.values(SIGNUP_ERROR).find((entry) => entry.name === code);
  return known?.message[language];
}
